import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=af118ef6&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=js&"
export * from "./Tips.vue?vue&type=script&lang=js&"
import style0 from "./Tips.vue?vue&type=style&index=0&id=af118ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af118ef6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af118ef6')) {
      api.createRecord('af118ef6', component.options)
    } else {
      api.reload('af118ef6', component.options)
    }
    module.hot.accept("./Tips.vue?vue&type=template&id=af118ef6&scoped=true&", function () {
      api.rerender('af118ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_islide_landing/components/AppSale/Tips.vue"
export default component.exports